/**
 * TKP-127 — Envanter ekranının özellik görünümleri ve Toplama/Saklama/Arşiv tablosu için saf yardımcılar (store/Vue yok).
 *
 * Üç görünüm (Veri / İlgili Kişi / Toplama) TKP-27 6.2'de birbirini dışlamıyordu; üçü birden açılınca tablo
 * düzeni tamamen bozuluyordu. Artık aynı anda EN FAZLA biri açık.
 */
export const FEATURE_VIEWS = [
  { key: "nodeFeatures", label: "inventory.data-features" },
  { key: "datasubjectFeatures", label: "inventory.datasubject-features" },
  { key: "datasourceFeatures", label: "inventory.datasource-features" },
];
/** Açık olana basınca kapanır (hiçbiri açık değil → temel tablo); başkasına basınca yalnız o açılır. */
export const nextFeatureView = (current, clicked) => (current === clicked ? null : clicked);
export const columnOptionsFor = (view) => Object.fromEntries(FEATURE_VIEWS.map((v) => [v.key, v.key === view]));

/**
 * TKP-129 — Toplama/Saklama/Arşiv görünümü VERİ bazlı: satır = süreç × veri (TKP-127'de süreç × kaynaktı).
 * TKP-126'dan beri bu kayıtlar veriye yazılıyor; kaynak satırlı tablo "Veri Kaynağı" sütunuyla hem verinin kendi
 * kayıtlarını göstermiyor hem de veri süzgecine uymuyordu. Verisi olmayan süreç "-" diye TEK satırla görünür.
 */
export const dataRowsOf = (process) => (process && process.processDatas && process.processDatas.length ? process.processDatas : [null]);
export const dataRowspanOfDepartment = (department) => (department.processes || []).reduce((n, p) => n + dataRowsOf(p).length, 0) || 1;

/**
 * Verinin KULLANDIĞI süreç×kaynak kayıtları: süreç kaynakları (`process.datasources`, her biri `datasource` taşır)
 * içinden verinin kaynak listesinde (`node.datasources`) olanlar. Kullanmadığı kaynağın kayıtları gösterilmez.
 */
export const nodeProcessDatasources = (process, node) => {
  const mine = new Set(((node && node.datasources) || []).map((d) => String(d && d._id)));
  return ((process && process.datasources) || []).filter((pd) => mine.has(String(pd && pd.datasource && pd.datasource._id)));
};

/** TKP-183 md.8: düğümün kaynak adları tek metin (virgülle, tekrarsız; kaynak yoksa boş metin). */
export const datasourceNamesOf = (node, tr = (v) => v) => {
  const names = [];
  for (const d of (node && node.datasources) || []) {
    const name = tr(d && d.name);
    if (name && !names.includes(name)) names.push(name);
  }
  return names.join(", ");
};

/** TKP-201 (TKP-200 m.8): envanter tablosunda verinin satırları — her ilgili kişi bir satır; ilgili kişisi yoksa tek boş satır. */
export const inventoryRowsOf = (node) => (node && node.datasubjects && node.datasubjects.length ? node.datasubjects : [null]);

/** TKP-201: satırın saklama süresi — ilgili kişi satırına (TKP-195) girilmişse o, değilse verinin (düğüm) süresi. */
export const rowDisposalPeriodOf = (nodeInv, rowInv) => (rowInv && rowInv.disposalPeriod ? rowInv.disposalPeriod : nodeInv && nodeInv.disposalPeriod ? nodeInv.disposalPeriod : 0);
